<template>
  <div id="app">
    <search-bar ref="searchBarComponent">
      <div slot="search-tool">
      </div>
      <div slot="search-cont">

    <!--    <div class="item" style="width: 20%;">
          <div class="item-label">状态</div>
          <el-select v-model="info.status" size="small" slot="prepend" placeholder="请选择状态" @change="getTableData">
            <el-option label="不限" value=""></el-option>
            <el-option label="入职" value="5"></el-option>
            <el-option label="离职" value="6"></el-option>
          </el-select>
        </div> -->

        <div class="item" style="width: 20%;">
          <div class="item-label">保险状态</div>
          <el-select v-model="info.insurestatus" size="small" slot="prepend" placeholder="请选择状态" @change="getTableData">
            <el-option label="不限" value=""></el-option>
            <el-option label="未参保" value="1"></el-option>
            <el-option label="已参保" value="2"></el-option>
            <el-option label="已退保" value="3"></el-option>
          </el-select>
        </div>




        <div class="item" style="width: 20%;">
          <div class="item-label">工厂</div>
          <el-select v-model="info.company_id" size="small" slot="prepend" placeholder="请选择工厂" @change="workChange"
            filterable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(item,index) in companyList" :key='index' :label="item.companyname" :value="item.id"></el-option>
          </el-select>
        </div>



        <div class="item">
          <div class="item-label">入职时间</div>
          <el-date-picker v-model="info.begintimes" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" size="mini" @change="interviewTimeChange"></el-date-picker>
        </div>

        <div class="item" >
          <div class="item-label">面试时间</div>
          <el-date-picker v-model="info.interviewTime" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" size="mini" @change="interviewTimeChanges"></el-date-picker>
        </div>

        <div class="item" style="width: 50%;margin-top: 20px;">
          <div class="item-label">关键词搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small" @keyup.enter.native='searchResume'>
              <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                <el-option label="姓名" value="1"></el-option>
                <el-option label="电话号码" value="2"></el-option>
                <!-- <el-option label="面试工厂" value="3"></el-option> -->
                <el-option label="面试职位" value="4"></el-option>
                <el-option label="录入人" value="5"></el-option>
                <el-option label="面试推荐人" value="7"></el-option>
                <el-option label="招聘专员" value="6"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
            </el-input>
          </div>
        </div>

      </div>
    </search-bar>

    <div class="operation-tool">
      <div @click="exportData()" class="tool-item"> <img src="../../../static/img/btn/export.png" />导出</div>
    </div>

    <div class="l-panel">
     <div class="panel-body">
      <el-table class="l-table-new-s" stripe="" :data="tableData" style="width: 100%;" :max-height="300">
        <el-table-column prop="resume_name" label="姓名" width="100" fixed="left" align="left">
          <template slot-scope="{row}">
            <el-link @click="openResumeDialog(row)">{{row.resume_name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="telephone" label="手机号码" width="110" align="left"></el-table-column>
        <el-table-column prop="sex_cn" label="性别" width="50" align="left"> </el-table-column>
        <el-table-column prop="birthdate" label="年龄" width="50" align="left"></el-table-column>
        <el-table-column prop="company_name" label="在职工厂" width="140" align="left"> </el-table-column>
        <el-table-column prop="date" label="保险类型" width="120" align="left">
          <template slot-scope='{row}'>
            <span v-if="row.insuretype == 2">商业险</span>
            <span v-if="row.insuretype == 3">单工伤+商业险</span>
            <span v-if="row.insuretype == 1">单工伤</span>
            <span v-if="row.insuretype == 4">社保</span>
            <span v-if="row.insuretype == 5">社保+商业险</span>
          </template>
        </el-table-column>
        <el-table-column prop="insureremark" label="保险备注" width="80" align="left">
          <template slot-scope='{row}'>
            <el-popover placement="top-start" title="保险备注" width="80" trigger="hover" :content="row.insureremark" >
              <div slot="reference" style="width: 80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{row.insureremark}}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="保险状态" width="80" align="left">
          <template slot-scope='{row}'>
            <template v-if="row.insureneed == 2">
              <span>-</span>
            </template>
            <template v-else>
              <span v-if="row.insurestatus == 2">已参保</span>
              <span v-if="row.insurestatus == 1">未参保</span>
              <span v-if="row.insurestatus == 3">已退保</span>
            </template>

          </template>
        </el-table-column>
        <el-table-column prop="date" label="参保状态" width="80" align="left">
          <template slot-scope='{row}'>
            <span v-if="row.insureneed == 2">无需参保</span>
            <span v-if="row.insureneed == 1">需要参保</span>
          </template>
        </el-table-column>
        <el-table-column prop="jobs_name" label="在职岗位" width="140" align="left"> </el-table-column>
        <el-table-column prop="project" label="所属项目" width="140" align="left"></el-table-column>
        <el-table-column prop="leavetime" label="离职时间" width="140" align="left"></el-table-column>
        <el-table-column prop="entry_time" label="入职时间" width="140" align="left"></el-table-column>
        <el-table-column prop="interview_time" label="面试时间" width="140" align="left"></el-table-column>
        <el-table-column prop="wadminname" label="录入人" width="120" align="left"></el-table-column>
        <el-table-column prop="recommendadmin" label="面试推荐人" width="120" align="left"></el-table-column>
        <el-table-column prop="adminname" label="招聘专员" width="120" align="left">
          <template slot-scope='{row}'>
            {{row.adminname}}<img v-if="row.utype==2" style="width:27px ;height: 17px;" src="../../images/icon/agent.png" alt />
          </template>
        </el-table-column>
        <el-table-column prop="date" label="工作类型" align="left">
          <template slot-scope='{row}'>
            <span v-if="row.wtype == 1">正式工</span>
            <span v-if="row.wtype == 2">临时工</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplyer1" label="供应商" width="140" align="left"></el-table-column>
        <el-table-column prop="supplyer2" label="被供应商" width="140" align="left"></el-table-column>
        <el-table-column prop="date" label="状态" width="65" align="left">
          <template slot-scope='{row}'>
            <span v-if="row.status == 5">在职</span>
            <span v-if="row.status == 6">离职</span>
          </template>
        </el-table-column>
        <el-table-column prop="leavereason" label="离职原因" width="100" align="left">
        </el-table-column>
        <el-table-column prop="date" label="操作" width="300" align="center" fixed="right">
          <template slot-scope='{row}'>

              <el-button type="primary" size='mini' v-if='row.status == 6 && row.wauth == 2' @click='infoChanges(row)'>查看信息</el-button>
             <!-- <el-button type="primary" size='mini' v-if='row.status != 6' @click='infoChange(row)'>信息修改</el-button>
              <el-button type="primary" size='mini' v-if='row.status != 6' @click='borrow(row)'>借资</el-button>
              <el-button type="primary" size='mini' v-if='row.status != 6' @click='insurance(row)'>保险</el-button>
              <el-button type="primary" size='mini' v-if='row.status != 6' @click='quit(row)'>离职</el-button> -->
                <el-button type="primary" size='mini' @click='changeLeavedate(row)' v-if="row.wauth == 2">更改时间</el-button>
              <el-button type="primary" size='mini' @click='changeRecommend(row)' v-if="row.zystatus == 2">更换专员</el-button>
              <el-button type="primary" size='mini' @click='quitInsurance(row)' v-if="row.insurestatus == 2">退保</el-button>

          </template>
        </el-table-column>

      </el-table>
      <div class="c-table-pager">
        <el-pagination  :total="total" @current-change='paginationChange'> </el-pagination>
      </div>
      </div>
    </div>



    <el-dialog title="离职详情" :visible.sync="dialogReason" width="100%" class='dialogClass'>
      <div class="userInfos">
        <div class="userInfoItem">
          <div class="userInfoTitle">姓名：</div>
          <div class="userInfoData">{{userInfo.resume_name}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">电话：</div>
          <div class="userInfoData">{{userInfo.telephone}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">性别：</div>
          <div class="userInfoData">{{userInfo.sex_cn}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">入职工厂：</div>
          <div class="userInfoData">{{userInfo.company_name}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">面试时间：</div>
          <div class="userInfoData">{{userInfo.interview_time}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">入职时间：</div>
          <div class="userInfoData">{{userInfo.entry_time}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">录入人：</div>
          <div class="userInfoData">{{userInfo.recommendadmin}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">合同时间：</div>
          <div class="userInfoData">{{userInfo.contract_begin}} - {{userInfo.contract_end}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">工作类型：</div>
          <div class="userInfoData">{{userInfo.wtype}}</div>
        </div>
        <div class="userInfoItem"></div>
        <div class="userInfoItem">
          <div class="userInfoTitle">身份证号码：</div>
          <div class="userInfoData">{{userInfo.idcard}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">银行卡：</div>
          <div class="userInfoData">{{userInfo.bankcard}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">保险状态：</div>
          <div class="userInfoData">{{userInfo.insurestatus}}</div>
        </div>
        <div class="userInfoItem">
          <div class="userInfoTitle">保险种类：</div>
          <div class="userInfoData">{{userInfo.insuretype}}</div>
        </div>
      </div>
      <div class="containerReason">
        <el-input type="textarea" placeholder="请输入内容" v-model="reason" class='textareaInput'> </el-input>
        <div style="margin-top: 20px;">
          <el-date-picker v-model="leavetime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="借支" :visible.sync="dialogBorrowDialog" width="100%" center>

      <div class="containerReason">
        <el-input type="number" placeholder="请输入借资金额" v-model="money"></el-input>
        <div style="height: 20px;width: 100%;"></div>
        <el-input type="text" placeholder="请输入经手人" v-model="handler" readonly> </el-input>
        <div style="margin-top: 20px;">
          <el-date-picker v-model="borrowTime" type="date" placeholder="选择借支时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm1">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="员工信息" :visible.sync="dialogVisible1" width="100%" center class='dialog1'>
      <div class="DialogListItem">
        <el-form ref="form" :model="form" label-width="100px" class="formContaier">

          <el-form-item label="员工名称" style="width: 40%;">
            <el-input v-model="form.resume_name" :readonly='disableState'></el-input>
          </el-form-item>

          <el-form-item label="工作类型" style="width: 40%;">
            <el-select v-model="form.wtypeName" placeholder="请选择工作类型" @change="wtypeChange" :disabled='disableState'>
              <el-option label="正式工" value="1"></el-option>
              <el-option label="临时工" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="性别" style="width: 40%;">
            <el-select v-model="form.sex_cn" placeholder="请选择工作类型" @change="sexChange" :disabled='disableState'>
              <el-option label="男" :value="[1,'男']"></el-option>
              <el-option label="女" :value="[2,'女']"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="员工出生年份" style="width: 40%;">
            <el-date-picker v-model="form.birthdate" type="year" placeholder="选择出生年份"  value-format="yyyy" :readonly='disableState' style="width: 100%;"></el-date-picker>
          </el-form-item>

          <el-form-item label="入职时间" style="width: 40%;">
            <el-date-picker type="datetime" placeholder="选择入职时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.entry_time"
              style="width: 100%;" :readonly='disableState'></el-date-picker>
          </el-form-item>

          <el-form-item label="面试时间" style="width: 40%;">
            <el-date-picker type="date" placeholder="选择面试时间" value-format="yyyy-MM-dd" v-model="form.interview_time"
              style="width: 100%;" :readonly='disableState'></el-date-picker>
          </el-form-item>

          <el-form-item label="在职岗位" style="width: 40%;">
            <el-input v-model="form.jobs_name" :readonly='disableState'></el-input>
          </el-form-item>

          <el-form-item label="合同时间" style="width: 45%;" v-if="form.wtype == 2">
            <el-date-picker v-model="form.contract" type="daterange" range-separator="-" start-placeholder="合同开始日期"
              value-format="yyyy-MM-dd" end-placeholder="合同结束日期" @change="contractChange" :readonly='disableState'></el-date-picker>
          </el-form-item>

          <el-form-item label="" style="width: 40%;" v-if="form.wtype != 2"></el-form-item>

          <el-form-item label="电话" style="width: 40%;">
            <el-input v-model="form.telephone" type='number' :readonly='disableState'></el-input>
          </el-form-item>
          <el-form-item label="" style="width: 40%;"></el-form-item>

          <el-form-item label="身份证号码" style="width: 40%;">
            <el-input v-model="form.idcard" :readonly='disableState'></el-input>
          </el-form-item>

          <el-form-item label="身份证正面">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="idcardfront" :on-success="handleAvatarSuccess"
              :headers="myHeaders" v-if='!disableState'>
              <img v-if="form.idcardfront" :src="form.idcardfront" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <img :src="form.idcardfront" alt="" v-else class="avatar" @click="handlePictureCardPreviews(form.idcardfront)">
          </el-form-item>

          <el-form-item label="身份证有效期" style="width: 45%;">
              <el-date-picker v-model="form.idcardtime"  type="daterange" range-separator="-" start-placeholder="生效日期" end-placeholder="失效日期"
               value-format="yyyy-MM-dd" @change="idDatetChange"></el-date-picker>
            <!-- <el-date-picker v-model="form.idcardtime" type="date" placeholder="选择日期" :readonly='disableState' style="width: 100%;"></el-date-picker> -->
          </el-form-item>

          <el-form-item label="身份证反面">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="idcardreverse"
              :on-success="handleAvatarSuccess2" :headers="myHeaders" v-if='!disableState'>
              <img v-if="form.idcardreverse" :src="form.idcardreverse" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <img :src="form.idcardreverse" alt="" v-else class="avatar" @click="handlePictureCardPreviews(form.idcardreverse)">
          </el-form-item>

          <el-form-item label="银行卡号码" style="width: 33%;" v-if="form.wtype == 2">
            <el-input v-model="form.bankcard" :readonly='disableState' style="width: 100%;"></el-input>
          </el-form-item>

          <el-form-item label="银行卡开户行" style="width: 33%;" v-if="form.wtype == 2">
            <el-input v-model="form.bankname" :readonly='disableState' style="width: 100%;"></el-input>
          </el-form-item>

          <el-form-item label="银行卡" v-if="form.wtype == 2">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="bankcardfront"
              :on-success="handleAvatarSuccess3" :headers="myHeaders" v-if='!disableState'>
              <img v-if="form.bankcardfront" :src="form.bankcardfront" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <img :src="form.bankcardfront" alt="" v-else class="avatar" @click="handlePictureCardPreviews(form.bankcardfront)">
          </el-form-item>

          <el-form-item label="合同照片" v-if='fileList.length != 0'>
           <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" name="contractimg" :headers="myHeaders" disabled
            ref="upload" :on-success="handleAvatarSuccess4" list-type="picture-card"  :on-remove="handleRemove" :file-list="fileList" :on-preview="handlePictureCardPreview">
             <i class="el-icon-plus"></i>
           </el-upload>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSubmit" v-if="!disableState"> 提 交 </el-button>
      </span>
    </el-dialog>


    <el-dialog title="保险情况" :visible.sync="dialogInsurance" width="100%" center>
      <div class="switch" style="display: flex;margin-bottom: 20px;justify-content: center;">
        <el-switch v-model="insuranceInfo.insureneedSwitch" @change='insureneedChange' active-color="#13ce66"
          inactive-color="#eaeaea"></el-switch>
        <div class='title'>无需参保</div>
      </div>
      <div class='insuranceMain' v-show='insuranceInfo.insureneed === 1'>
        <el-form ref="form" :model="form" label-width="80px">

          <el-form-item label="保险状态">
            <el-select v-model="insuranceInfo.insurestatus_cn" placeholder="请选择保险状态" @change="insuranceStateChange">
              <el-option label="未参保" value="1"></el-option>
              <el-option label="已参保" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="保险类型">
            <el-select v-model="insuranceInfo.insuretype_cn" placeholder="请选择保险类型" @change="insuranceTypeChange">
              <el-option label="单工伤" value="1"></el-option>
              <el-option label="商业险" value="2"></el-option>
              <el-option label="单工伤+商业险" value="3"></el-option>
			  <el-option label="社保" value="4"></el-option>
			  <el-option label="社保 + 商业险" value="5"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注">
            <el-input v-model="insuranceInfo.insureremark"></el-input>
          </el-form-item>

        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormInsurance">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="更换招聘专员" :visible.sync="recommendDialog" width="30%">
      <div class="containerReason">
        <div class="recommendItem">
          <div class="title">原招聘专员：</div>
          <div class="selectName">{{selectName}}</div>
        </div>
        <div class="recommendItem">
          <div class="title">更换专员为：</div>
          <div class="selectName">
            <el-select v-model="recommendInfo.adminname" placeholder="请选择招聘专员" @change='recommendChanges'>
              <el-option v-for="item in recommendList" :key="item.uid" :label="item.oausername" :value="[item.uid,item.oausername,item.id]"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm4">提交</el-button>
      </span>
    </el-dialog>
<!--  更改离职时间  -->
    <el-dialog title="更改离职时间" :visible.sync="leavedateDialog" width="30%">
      <div class="containerReason">
        <div class="recommendItem">
          <div class="title">当前离职时间：</div>
          <div class="selectName">{{leavedataForm.currLeavetime}}</div>
        </div>
        <div class="recommendItem">
          <div class="title">更改离职时间为：</div>
          <div class="selectName">
            <el-date-picker v-model="leavedataForm.leavetime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitLeavedate">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <!-- 查看员工信息 start -->
        <el-dialog class="el-dialog-medium-x" title="员工信息" :visible.sync="dialogVisibleResume" width="100%"  center>
          <div class="resume-details-container" style="min-height: 500px;">
            <div class="e-update-date">
              <div class="update-date" style="margin-top: 0;">更新时间：{{resumeDetailsInfo_user.refreshtime}}</div>

            </div>
            <div class="e-userinfo-name" ><div class="e-sex" ><i :class="[resumeDetailsInfo_user.sex=2?'el-icon-female':'el-icon-male']" ></i></div><span class="e-name">{{resumeDetailsInfo_interview.resume_name}}</span><span class="e-tel">{{resumeDetailsInfo_user.telephone}}</span></div>

            <el-tabs v-model="activeTabName" @tab-click="handleResumeTabChange()">
              <el-tab-pane label="员工档案" name="first">
                <div>
                  <div class="resume-info">
                    <div class="info-left">
                      <div class="i-item">在职工厂：{{resumeDetailsInfo_interview.company_name}}</div>
                      <div class="i-item">在职岗位：{{resumeDetailsInfo_interview.jobs_name}}</div>
                      <div class="i-item">工作类型：{{resumeDetailsInfo_interview.wtype==1?"正式工":(resumeDetailsInfo_interview.wtype==2?"临时工":"")}}</div>
                      <div class="i-item">入职时间：{{resumeDetailsInfo_interview.entry_time}}</div>
                      <div class="i-item">面试时间：{{resumeDetailsInfo_interview.interview_time}}</div>
                      <div class="i-item">添加入职时间：{{resumeDetailsInfo_interview.setentry_time}}</div>
                      <div class="i-item">工作制度：{{resumeDetailsInfo_interview.resttype==1?"双休":(resumeDetailsInfo_interview.resttype==2?"单休":(resumeDetailsInfo_interview.resttype==3?"大小周":"") )}}</div>
                      <div class="i-item">上班时间：{{resumeDetailsInfo_interview.workbegin}}-{{resumeDetailsInfo_interview.workend}}, {{resumeDetailsInfo_interview.workhours}}小时</div>
                    </div>
                    <div class="info-right">
                      <div class="i-item">保险类型：
                      <span v-if="resumeDetailsInfo_interview.insuretype == 2">商业险</span>
                      <span v-if="resumeDetailsInfo_interview.insuretype == 3">单工伤+商业险</span>
                      <span v-if="resumeDetailsInfo_interview.insuretype == 1">单工伤</span>
                      <span v-if="resumeDetailsInfo_interview.insuretype == 4">社保</span>
                      <span v-if="resumeDetailsInfo_interview.insuretype == 5">社保 + 商业险</span>
                      </div>
                      <div class="i-item">保险备注：{{resumeDetailsInfo_interview.insureremark}} </div>
                      <div class="i-item">保险状态：
                        <span v-if="resumeDetailsInfo_interview.insurestatus == 2">已参保</span>
                        <span v-if="resumeDetailsInfo_interview.insurestatus == 1">未参保</span>
                      </div>
                      <div class="i-item">参保需求：
                        <span v-if="resumeDetailsInfo_interview.insureneed == 2">无需参保</span>
                        <span v-if="resumeDetailsInfo_interview.insureneed == 1">需要参保</span>
                      </div>
                      <div class="i-item">所属项目：{{resumeDetailsInfo_interview.project}}</div>
                      <div class="i-item">录入人：{{resumeDetailsInfo_user.wadminname}}</div>
                      <div class="i-item">推荐人：{{resumeDetailsInfo_interview.recommendadmin}}</div>
                      <div class="i-item">招聘专员：{{resumeDetailsInfo_user.adminname}}</div>
                    </div>
                  </div>

                  <div class="row-line"></div>

                  <div class="resume-info">
                    <div class="info-left">
                      <div class="i-item">身份证号：{{resumeDetailsInfo_interview.idcard}}</div>
                      <div class="i-item">身份证有效期：<span v-if="resumeDetailsInfo_interview.idcarddatestatus=2">长期</span> <span v-else>{{resumeDetailsInfo_interview.idcardstartdate}}-{{resumeDetailsInfo_interview.idcardenddate}}</span></div>
                      <div class="i-item" style="display: flex;"><el-image style="margin-right: 5px;" :src="resumeDetailsInfo_interview.idcardfront" :preview-src-list="[resumeDetailsInfo_interview.idcardfront]"></el-image>
                       <el-image :src="resumeDetailsInfo_interview.idcardreverse" :preview-src-list="[resumeDetailsInfo_interview.idcardreverse]"></el-image></div>
                      <div class="i-item" style="display: flex;"><div style="width: 120px;">合同照片：</div>
                        <div style="display: flex;">
                          <el-image style="margin-right: 5px;" v-for="(item,index) in resumeDetailsInfo_interview.contractimg" :key="index" :src="item" :preview-src-list="[item]" ></el-image>
                        </div>
                      </div>

                    </div>
                    <div class="info-right">
                      <div class="i-item">银行卡号码：{{resumeDetailsInfo_interview.bankcard}}</div>
                      <div class="i-item">银行卡开户行：{{resumeDetailsInfo_interview.bankname}}</div>
                      <div class="i-item"><el-image :src="resumeDetailsInfo_interview.bankcardfront"></el-image> <el-image :src="resumeDetailsInfo_interview.bankcardreverse"></el-image></div>

                    </div>
                  </div>




                </div>

              </el-tab-pane>
              <el-tab-pane label="面试详情" name="second">
                <div class="interview-history" >
                  <div class="el-steps el-steps--vertical">
                    <div v-for="(item,index) in resumeDetailsInfo_history" class="el-step is-vertical" style="flex-basis: 50%;">
                      <div class="el-step__head is-finish">
                        <div class="el-step__line" style="margin-right: 0px;">
                          <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; height: 0%;"></i>
                        </div>
                        <div class="el-step__icon is-text">
                          <div class="el-step__icon-inner">{{index+1}}</div>
                        </div>
                      </div>
                      <div class="el-step__main">
                        <div class="el-step__title is-finish">
                          <div class="i-company" >{{item.content}}</div>
                          <div class="i-time" >{{item.addtime}}</div>
                        </div>
                        <div class="el-step__description is-finish"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="借支记录" name="third">
                <div class="interview-history" >
                  <div class="el-steps el-steps--vertical">
                    <div v-for="(item,index) in resumeDetailsInfo_borrow" class="el-step is-vertical" style="flex-basis: 50%;">
                      <div style="color: #666666;font-size: 14px;margin-right: 15px;line-height: 24px;">{{item.borrowtime}}</div>
                      <div class="el-step__head is-finish">
                        <div class="el-step__line" style="margin-right: 0px;">
                          <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; height: 0%;"></i>
                        </div>
                        <div class="el-step__icon is-text">
                          <div class="el-step__icon-inner">{{index+1}}</div>
                        </div>
                      </div>
                      <div class="el-step__main">
                        <div class="el-step__title is-finish">
                          <div class="i-company" >{{item.type}}费用 <span class="num">{{item.money}}元</span></div>
                          <div class="i-time" >剩余待还{{item.leftmoney}}元</div>
                        </div>
                        <div class="el-step__description is-finish"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </el-tab-pane>

            </el-tabs>


          </div>
        </el-dialog>
    <!--     查看简历信息 end -->

  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          page: 1,
          status: '', //5入职，6离职
          insurestatus: '', //1未参保，2已参保
          begintime: '',
          endtime: '',
          key_type: '', //1:姓名，2电话号码，3面试工厂，4面试职位，5录入人
          key: '',
          company_name: '',
          company_id:''
        },
        form: {
          contract: [],
          resume_name: '',
          entry_time: '',
          contract_begin: '',
          contract_end: '',
          wtype: '',
          idcard: '',
          idcardfront: '',
          idcardreverse: '',
          bankcard: '',
          bankcardfront: '',
          bankname: '',
          idcardtime: [],
          idcardstartdate:'',
          idcardenddate:'',
          birthdate: '',
          sex_cn: '',
          sex: '',
          jobs_name: '',
          interview_time: '',
          telephone: ''
        },
        tableData: [],
        total: 1,
        selectId: '',
        dialogReason: false,
        reason: '',
        leavetime: '',
        money: '',
        borrowTime: '',
        dialogBorrowDialog: false,
        handler: '',
        dialogVisible1: false,
        userInfo: {},
        dialogInsurance: false,
        insuranceInfo: {
          insureneedSwitch: false,
          insureremark: ''
        },
        myHeaders: {},
        disableState: false,
        selectName: '',
        recommendDialog: false,
        recommendInfo: {
          user: [],
          adminname: '',
          adminid: '',
          resume_id: '',
        },
        recommendList: [],
        companyList: [],
        fileList:[],
        leavedateDialog:false,//更改离职时间窗口
        leavedataForm:{
          did:"",
          leavetime:"",
          currLeavetime:""
        },
        dialogImageUrl:'',
        dialogVisible:false,
        dialogVisibleResume:false,//查看员工简历信息
        activeTabName:"first",
        resumeDetailsInfo_user:{},//简历档案-用户信息
        resumeDetailsInfo_interview:{},//简历档案-最后面试
        resumeDetailsInfo_history:[],//面试详情 - 历史面试信息
        resumeDialogParam:{
          resume_id:'',//简历id
          did:"",//面试id
        },
        resumeDetailsInfo_borrow:[],//借支记录

      }
    },
    mounted() {
      let token = this.$store.state.token;
      let token_type = this.$store.state.token_type;
      this.myHeaders = {
        authorization: token_type + " " + token,
      };
      this.getTableData()
      this.getRecommendList()
      this.getCompanyList()
      console.log(this.$store.state.username)
      this.handler = this.$store.state.username
    },

    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=true");
          });
    },

    methods: {


      handlePictureCardPreview(file) {
         this.dialogImageUrl = file.url;
         this.dialogVisible = true;
      },

      handlePictureCardPreviews(url){
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      },


      quitInsurance(row){
        this.gets('oasystem/surrender',{did:row.did}).then(res=>{
          if(res.data.code == 1){
            Message.success(res.data.msg)
          }else{
            Message.warning(res.data.msg)
          }
          this.getTableData()
        })
      },

      exportData(){
        this.gets('oasystem/leaveerlistdc',this.info).then(res=>{
          var tempwindow=window.open('_blank')
          tempwindow.location= res.data
        })
      },

      idDatetChange(val){
        this.form.idcardstartdate = val[0]
        this.form.idcardenddate = val[1]
        console.log(this.form)
      },

      workChange(val) {
        this.info.company_id = val
        this.getTableData()
      },

      getCompanyList() {
        this.gets('oasystem/catecompanylist').then(res => {
          this.companyList = res.data.data
        })
      },

      changeRecommend(row) {
        this.selectName = row.adminname || '暂无信息'
        this.selectId = row.resume_id
        this.recommendDialog = true
      },

      submitForm4() {
        console.log(this.selectId)
        this.recommendInfo.resume_id = this.selectId
        if (!this.recommendInfo.adminid) {
          return Message.success('请选择招聘专员')
        }
        this.post('oasystem/setmanage', this.recommendInfo).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.recommendInfo = {}
          this.recommendDialog = false
          this.getTableData()
        })
      },
      //显示更改离职时间窗口
      changeLeavedate(row) {
        this.leavedateDialog = true
        this.leavedataForm.did = row.did
        this.leavedataForm.currLeavetime = row.leavetime
      },
      submitLeavedate() {
        if (!this.leavedataForm.leavetime) {
          return Message.success('请选择离职时间')
        }
        this.leavedataForm.isChange = 1;
        this.post('oasystem/setleave', this.leavedataForm).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.leavedateDialog = false
          this.getTableData()
          for(let key in this.leavedataForm) {
            this.leavedataForm[key] = ""
          }
        })
      },

      sexChange(val) {
        this.form.sex_cn = val[1]
        this.form.sex = val[0]
        this.$forceUpdate()
      },

      recommendChanges(val) {
        this.recommendInfo.adminid = val[0]
        this.recommendInfo.adminname = val[1]
        this.recommendInfo.utypeid = val[2]
        this.$forceUpdate()
      },

      getRecommendList() {
        this.gets('oasystem/cateadminlist').then(res => {
          this.recommendList = res.data.data
        })
      },

      submitFormInsurance() {
        this.insuranceInfo.did = this.selectId
        if (!this.insuranceInfo.insureneedSwitch) {
          if (!this.insuranceInfo.insurestatus) {
            return this.$notify({
              title: '提示',
              message: '请选择保险状态',
              type: 'warning'
            });
          }
          if (!this.insuranceInfo.insuretype) {
            return this.$notify({
              title: '提示',
              message: '请选择保险种类',
              type: 'warning'
            });
          }
        }
        this.post('oasystem/setinsure', this.insuranceInfo).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.insuranceInfo = {
            insurestatus_cn: '',
            insuretype_cn: '',
            insureremark: ''
          }
          this.dialogInsurance = false
          this.getTableData()
        })
      },

      submitForm1() {
        let info = {}
        info.did = this.selectId
        info.borrowtime = this.borrowTime
        info.money = this.money
        info.handler = this.handler
        if (!info.money) {
          return Message.warning('请填写借资金额')
        }
        if (!info.borrowtime) {
          return Message.warning('请选择借资时间')
        }
        // if (!info.handler) {
        //   return Message.warning('请填写经手人')
        // }
        this.post('oasystem/addborrow', info).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.dialogBorrowDialog = false
          this.getTableData()
          this.borrowTime = ''
          this.money = ''
          // this.handler = ''
        })
      },


      submitForm() {
        let info = {}
        info.did = this.selectId
        info.leavereason = this.reason
        info.leavetime = this.leavetime
        if (!info.leavereason) {
          return Message.warning('请填写离职原因')
        }
        if (!info.leavetime) {
          return Message.warning('请选择离职时间')
        }
        this.post('oasystem/setleave', info).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.dialogReason = false
          this.getTableData()
          this.reason = ''
          this.leavetime = ''
        })
      },

      formSubmit() {
        let form = this.form
        if (!form.resume_name) {
          return this.$notify({
            title: '提示',
            message: '请填写员工姓名',
            type: 'warning'
          });
        }
        if (!form.entry_time) {
          return this.$notify({
            title: '提示',
            message: '请选择入职时间',
            type: 'warning'
          });
        }
        if (!form.wtype) {
          return this.$notify({
            title: '提示',
            message: '请选择工作类型',
            type: 'warning'
          });
        }
        if (!form.idcard && form.wtype == 2) {
          return this.$notify({
            title: '提示',
            message: '请填写身份证号码',
            type: 'warning'
          });
        }
        // if(!form.bankcard && form.wtype == 2){
        //   return this.$notify({ title: '提示',message: '请填写银行卡号',type: 'warning' });
        // }
        // if(!form.bankname && form.wtype == 2){
        //   return this.$notify({ title: '提示',message: '请填写银行卡开户行',type: 'warning' });
        // }
        this.post('oasystem/entryadd', this.form).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
          } else {
            Message.warning(res.data.msg)
          }
          this.dialogVisible1 = false
          this.getTableData()
        })
      },

      insurance(val) {
        this.selectId = val.did
        this.gets('oasystem/resumeinfo', {
          resume_id: val.resume_id
        }).then(res => {
          if (res.data.data) {
            let interviewinfo = res.data.data.interviewinfo
            if (interviewinfo.insureneed == 1) {
              this.insuranceInfo.insureneed = interviewinfo.insureneed
              this.insuranceInfo.insureneedSwitch = interviewinfo.insureneed == 1 ? false : true
              this.insuranceInfo.insuretype_cn = interviewinfo.insuretype == 1 ? '单工险' : interviewinfo.insuretype ==
                2 ? '商业险' : interviewinfo.insuretype == 3 ? '单工伤+商业险' : interviewinfo.insuretype == 4 ? '社保' :interviewinfo.insuretype == 5 ? '社保 + 商业险':''
              this.insuranceInfo.insuretype = interviewinfo.insuretype
              this.insuranceInfo.insurestatus_cn = interviewinfo.insurestatus == 1 ? '未参保' : '已参保'
              this.insuranceInfo.insurestatus = interviewinfo.insurestatus
              this.insuranceInfo.insureremark = interviewinfo.insureremark
              console.log(interviewinfo)
            } else {
              this.insuranceInfo = {
                insureneedSwitch: true
              }
            }

            this.dialogInsurance = true
          }
        })
      },

      insureneedChange(val) {
        this.insuranceInfo.insureneed = val ? 2 : 1
        this.$forceUpdate()
      },

      borrow(val) {
        this.selectId = val.did
        this.dialogBorrowDialog = true
        this.money = ''
        // this.handler = ''
        this.borrowTime = ''
      },

      infoChange(val) {
        this.selectId = val.did
        this.gets('oasystem/resumeinfo', {
          resume_id: val.resume_id,
          did:val.did
        }).then(res => {
          this.disableState = false
          if (res.data.data) {
            this.dialogVisible1 = true
            let resumeinfo = res.data.data.resumeinfo
            let interviewinfo = res.data.data.interviewinfo
            this.form.did = interviewinfo.did
            this.form.resume_name = resumeinfo.fullname
            // this.form.entry_time = interviewinfo.entry_time
            this.$set(this.form, "entry_time", interviewinfo.entry_time + ':00');
            this.form.contract_begin = interviewinfo.contract_begin
            this.form.contract_end = interviewinfo.contract_end
            this.form.wtypeName = interviewinfo.wtype == 2 ? '临时工' : '正式工'
            this.form.wtype = interviewinfo.wtype
            this.form.contract[0] = interviewinfo.contract_begin
            this.form.contract[1] = interviewinfo.contract_end
            this.form.idcard = interviewinfo.idcard
            this.form.idcardfront = interviewinfo.idcardfront
            this.form.idcardreverse = interviewinfo.idcardreverse
            this.form.bankcard = interviewinfo.bankcard
            this.form.bankcardfront = interviewinfo.bankcardfront
            this.form.bankname = interviewinfo.bankname
            this.form.sex = resumeinfo.sex
            this.form.sex_cn = resumeinfo.sex_cn
            this.form.birthdate = resumeinfo.birthdate + ''
            this.form.telephone = resumeinfo.telephone
            this.form.interview_time = interviewinfo.interview_time
            this.form.jobs_name = interviewinfo.jobs_name
            this.form.idcardtime[1] = interviewinfo.idcardenddate
            this.form.idcardtime[0] = interviewinfo.idcardstartdate
            this.form.idcardstartdate = interviewinfo.idcardstartdate
            this.form.idcardenddate = interviewinfo.idcardenddate
            this.fileList =  interviewinfo.contractimg.map((item)=>{
                item = {url:item}
                return item
              })
          }
        })
      },
      infoChanges(val) {
        this.selectId = val.did
        this.gets('oasystem/resumeinfo', {
          resume_id: val.resume_id,
          did:val.did
        }).then(res => {
          if (res.data.data) {
            this.disableState = true
            this.dialogVisible1 = true
            let resumeinfo = res.data.data.resumeinfo
            let interviewinfo = res.data.data.interviewinfo
            this.form.did = interviewinfo.did
            this.form.resume_name = resumeinfo.fullname
            this.form.entry_time = interviewinfo.entry_time
            this.form.contract[0] = interviewinfo.contract_begin
            this.form.contract[1] = interviewinfo.contract_end
            this.form.contract_begin = interviewinfo.contract_begin
            this.form.contract_end = interviewinfo.contract_end
            this.form.wtypeName = interviewinfo.wtype == 2 ? '临时工' : '正式工'
            this.form.wtype = interviewinfo.wtype
            this.form.idcard = interviewinfo.idcard
            this.form.idcardfront = interviewinfo.idcardfront
            this.form.idcardreverse = interviewinfo.idcardreverse
            this.form.bankcard = interviewinfo.bankcard
            this.form.bankname = interviewinfo.bankname
            this.form.bankcardfront = interviewinfo.bankcardfront
            this.fileList =  interviewinfo.contractimg.map((item)=>{
                item = {url:item}
                return item
              })
          }
        })
      },

      quit(val) {
        this.selectId = val.did
        this.gets('oasystem/resumeinfo', {
          resume_id: val.resume_id
        }).then(res => {
          if (res.data.data) {
            this.dialogReason = true
            let resumeinfo = res.data.data.resumeinfo
            let interviewinfo = res.data.data.interviewinfo
            // this.userInfo.did = interviewinfo.did
            this.userInfo.resume_name = resumeinfo.fullname
            this.userInfo.telephone = resumeinfo.telephone
            this.userInfo.sex_cn = resumeinfo.sex_cn
            this.userInfo.company_name = interviewinfo.company_name
            this.userInfo.interview_time = interviewinfo.interview_time
            this.userInfo.entry_time = interviewinfo.entry_time
            this.userInfo.recommendadmin = interviewinfo.recommendadmin
            this.userInfo.contract_begin = interviewinfo.contract_begin
            this.userInfo.contract_end = interviewinfo.contract_end
            this.userInfo.wtype = interviewinfo.wtype == 1 ? '正式工' : '临时工'
            this.userInfo.idcard = interviewinfo.idcard
            this.userInfo.bankcard = interviewinfo.bankcard
            this.userInfo.bankname = interviewinfo.bankname
            this.userInfo.insurestatus = interviewinfo.insurestatus == 1 ? '未参保' : '已参保'
            this.userInfo.insuretype = interviewinfo.insuretype

            this.leavetime = ''
            this.reason = ''
          } else {
            Message.warning('网络错误')
          }

        })
      },

      searchResume() {
        if(!this.info.key_type){
           return Message.warning('请选择搜索类型')
        }
        this.info.page = 1
        this.getTableData()
      },

      getTableData() {
        this.gets('oasystem/leaveerlist', this.info).then(res => {
          this.total = res.data.data.total
          this.tableData = res.data.data.list
        })
      },

      interviewTimeChange(val) {
        this.info.begintime = val?val[0]:''
        this.info.endtime = val?val[1]:''
        this.info.begintimes = val
        this.getTableData()
      },

      interviewTimeChanges(val) {
        this.info.begintime2 = val?val[0]:''
        this.info.endtime2 = val?val[1]:''
        this.info.interviewTime = val
        this.getTableData()
      },

      paginationChange(val) {
        this.info.page = val
        this.getTableData()
      },

      contractChange(val) {
        this.form.contract_begin = val[0]
        this.form.contract_end = val[1]
      },

      wtypeChange(val) {
        this.form.wtypeName = val == 1 ? '正式工' : '临时工',
          this.form.wtype = val
        if (val == 1) {
          this.form.contract_begin = ''
          this.form.contract_end = ''
          this.form.bankcard = ''
          this.form.bankname = ''
          this.form.bankcardfront = ''
        } else {
          this.form.contract[0] = ''
          this.form.contract[1] = ''
        }
        this.$forceUpdate()
      },

      insuranceStateChange(e) {
        this.insuranceInfo.insurestatus = e
        this.insuranceInfo.insurestatus_cn = e == 1 ? '未参保' : '已参保'
        this.$forceUpdate()
      },

      insuranceTypeChange(e) {
        this.insuranceInfo.insuretype = e
        this.insuranceInfo.insuretype_cn = e == 1 ? '单工伤' : e == 2 ? '商业险' : e == 3? '单工伤+商业险' :e ==4?'社保':'社保 + 商业险'
        this.$forceUpdate()
      },

      handleAvatarSuccess(res) {
        if (res.data.cardnum != '无效') {
          this.form.idcardfront = res.data.img
          this.form.idcard = res.data.cardnum
        } else {
          Message.warning('无效图片')
        }
      },

      handleAvatarSuccess2(res) {
        if (res.data.cardnum != '无效' && res.data.cardnum != '过期') {
          this.form.idcardreverse = res.data.img
          this.form.idcardenddate = res.data.cardnum.EndDate
          this.form.idcardstartdate = res.data.cardnum.StartDate
          let array = [res.data.cardnum.StartDate,res.data.cardnum.EndDate]

          this.form.idcardtime = array
          console.log(this.form.idcardtime)
        } else if (res.data.cardnum == '过期') {
          Message.warning('身份证过期')
        } else {
          Message.warning('无效图片')
        }
      },

      handleAvatarSuccess3(res) {
        if (res.data.cardnum != '无效') {
          this.form.bankcardfront = res.data.img
          this.form.bankcard = res.data.cardnum
        } else {
          Message.warning('无效图片')
        }
      },
      /******查看员工信息 start*************************/
      //查看员工信息
      openResumeDialog(row) {
        this.dialogVisibleResume = true;
        this.resumeDialogParam.resume_id = row.resume_id;
        this.resumeDialogParam.did = row.did;
        if(this.activeTabName=='first') {
          this.getResumeInfo()
        }else if(this.activeTabName=='second') {
          this.getInterviewHistory()
        }else if(this.activeTabName=='third') {
          this.getBorrowHistory()
        }

      },
      //获取简历档案
      getResumeInfo() {
        this.gets('oasystem/resumeinfo', {resume_id:this.resumeDialogParam.resume_id,did:this.resumeDialogParam.did}).then(res => {
          if (res.data.code == 1) {
            this.resumeDetailsInfo_user = res.data.data.resumeinfo;
            this.resumeDetailsInfo_interview = res.data.data.interviewinfo|| {};

          } else {
            Message.warning(res.data.msg)
          }
        })
      },
      //获取简历信息 - 面试详情
      getInterviewHistory() {
        this.gets('v2/worker/operateList', {resume_id:this.resumeDialogParam.resume_id}).then(res => {
          if (res.data.code == 1) {
            this.resumeDetailsInfo_history = res.data.data;

          } else {
            Message.warning(res.data.msg)
          }
        })
      },
      getBorrowHistory() {
        this.gets('v2/worker/borrowList', {did:this.resumeDialogParam.did}).then(res => {
          if (res.data.code == 1) {
            this.resumeDetailsInfo_borrow = res.data.data.list;

          } else {
            Message.warning(res.data.msg)
          }
        })
      },
      handleResumeTabChange() {
        if(this.activeTabName=='first') {
          this.getResumeInfo()
        }else if(this.activeTabName=='second') {
          this.getInterviewHistory()
        }else if(this.activeTabName=='third') {
          this.getBorrowHistory()
        }
      },
      /******查看员工信息 end*************************/


    }
  }
</script>

<style scoped>
  .container {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
  }

  .dialog1>>>.el-dialog {
    max-width: 1100px
  }

  .DialogListItem {
    display: flex;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 80px;
    display: block;
    cursor: pointer;
  }

  .dialog1>>>.el-form-item {
    min-width: 30%;
  }

  .dialog1>>>.el-upload {
    border: 1px dashed #d9d9d9;
  }

  .formContaier {
    display: flex;
    flex-wrap: wrap;
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn {
    display: flex;
  }

  .textareaInput>>>textarea {
    height: 180px;
    resize: none;
  }

  .containerReason>>>.el-date-editor {
    width: 100%;
  }

  .userInfos {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .userInfoItem {
    width: 40%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .dialogClass>>>.el-dialog {
    max-width: 800px;
  }

  .title {
    margin-left: 20px;
  }

  .recommendItem {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .export{
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/oasystem/oaleaveerlist.vue